import { Colors } from "@/enums/Colors";
import { Box, Button, Dialog, DialogContent, Typography, styled } from "@mui/material";

const StyledButton = styled(Button)(({ theme }) => ({
  width: "158.5px",
  height: "44px",
  textTransform: "none",
  padding: 0,
  borderRadius: "8px",
  fontSize: "14px",
  "&.cancel-button": {
    color: Colors.BUTTON_HOVER_PURPLE,
    backgroundColor: Colors.WHITE,
    border: `1px solid ${Colors.BUTTON_HOVER_PURPLE}`,
  },
  "&.delete-button": {
    color: Colors.WHITE,
    backgroundColor: Colors.HEART_RED,
  },
}));

const StyledDialog = styled(Dialog)(({ theme }) => ({
  position: "absolute",
  "& .MuiDialog-paper": {
    width: "381px",
    height: "180px",
    borderRadius: "1rem",
    "& .MuiDialogContent-root": {
      padding: "24px",
      overflow: "hidden",
    },
  },
}));

const Container = styled(Box)(({ theme }) => ({
  "&.content-container": {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
  },
  "&.button-container": {
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "row",
    height: "44px",
    gap: "1rem",
  },
}));

const Text = styled(Typography)(({ theme }) => ({
  "&.modal-title": {
    fontWeight: "bold",
    fontSize: "14px",
  },
  "&.modal-content": {
    color: Colors.LIGHT_GRAY_8A8E93,
    fontSize: "12px",
  },
}));

interface Props {
  showDeleteModal: boolean;
  conversationTitle: string;
  handleOnClose: () => void;
  handleDelete: () => void;
  isChecklist?: boolean;
}

export const DeleteConversationModal = ({ showDeleteModal, conversationTitle, handleOnClose, handleDelete, isChecklist }: Props) => {
  return (
    <StyledDialog sx={{ position: "absolute" }} open={showDeleteModal} onClose={handleOnClose}>
      <DialogContent>
        <Container className="content-container">
          <Text className="modal-title">Delete {isChecklist ? "check item" : "chat"}?</Text>
          <Text className="modal-content">
            {isChecklist
              ? "Would you like to delete this check item? All data will be lost."
              : `Would you like to delete '${conversationTitle} for all members?'`}
          </Text>
          <Container className="button-container">
            <StyledButton className="cancel-button" onClick={handleOnClose}>
              Cancel
            </StyledButton>
            <StyledButton className="delete-button" onClick={handleDelete}>
              Delete
            </StyledButton>
          </Container>
        </Container>
      </DialogContent>
    </StyledDialog>
  );
};
